module.exports = __webpack_public_path__ + "static/media/seoul.59dad4c0.jpg";